export default "__VITE_ASSET__CbhCpti3__"